import { UserCultureEnum } from "../enums/user-culture.enum.model";

export class Culture {
  id: UserCultureEnum;
  title: string;
  shortTitle: string;
  flag: string;
}


export class CultureList {
  cultureList: Culture[];
  constructor(init?: Partial<CultureList>) {
    Object.assign(this, init);
    if (!this.cultureList) {
      this.cultureList = [
        {
          id: UserCultureEnum.it,
          title: 'Italian',
          shortTitle: 'it',
          flag: 'it'
        },
        {
          id: UserCultureEnum.fr,
          title: 'French',
          shortTitle: 'fr',
          flag: 'fr'
        },
        {
          id: UserCultureEnum.en,
          title: 'English',
          shortTitle: 'en',
          flag: 'us'
        },
        {
          id: UserCultureEnum.es,
          title: 'Spanish',
          shortTitle: 'es',
          flag: 'es'
        },
        {
          id: UserCultureEnum.de,
          title: 'German',
          shortTitle: 'de',
          flag: 'de'
        }
      ];
    }
  }

  getCulture(id: UserCultureEnum) {
    return this.cultureList.find(x => x.id === id);
  }

  getShortTitle(id: UserCultureEnum) {
    return this.cultureList.find(x => x.id === id)?.shortTitle;
  }

  getShortTitleList(): string[] {
    return this.cultureList.map(x => x.shortTitle);
  }
}


